import { ICobrancaRelatorio } from "@/models/consignado/proposal-billings.model";
import { renderCompetenciaFromDate } from "@/utils/consignado/renderCompetencia.utils";
import { Box, Flex, Text, Tooltip } from "@chakra-ui/react";

// 🔑 chaves fixas
const chaves = ["escriturado", "nao_escriturado", "repassado", "nao_repassado", "total"] as const;
type Chave = typeof chaves[number];

// 🎨 cores
const cores: Record<Chave, string> = {
  total: "gray.400",
  escriturado: "green.400",
  nao_escriturado: "red.400",
  repassado: "blue.400",
  nao_repassado: "orange.400",
};

// 🏷 labels
const labels: Record<Chave, string> = {
  total: "Total",
  escriturado: "Escriturado",
  nao_escriturado: "Não Escriturado",
  repassado: "Repassado",
  nao_repassado: "Não Repassado",
};

type Props = {
  data: ICobrancaRelatorio[];
};

export default function RelatorioDetalhe({ data }: Props) {
  return (
    <Box px={10} >
      <Flex direction="column" gap={8} w="100%">
        {data.map((relatorio, i) => {
          // 🔝 máximo da competência para normalizar barras
          const maxCompetencia = Math.max(
            ...relatorio.parcelas.flatMap((p) => chaves.map((k) => p[k]))
          );

          return (
            <Box key={`competencia-${i}`}>
              {/* título da competência */}
              <Text fontWeight="bold" mb={2}>
                Competência: {renderCompetenciaFromDate(new Date(relatorio.competencia))} 
              </Text>

              {/* linha de parcelas com scroll individual */}
              <Flex align="flex-end" gap={10} overflowX="auto" py={2}>
                {relatorio.parcelas.map((parcela, j) => (
                  <Flex
                    key={`parcela-${j}`}
                    direction="column"
                    align="center"
                    gap={1}
                    // minW="70px"
                  >
                    {/* barras da parcela */}
                    <Flex align="flex-end" gap={1} h="150px">
                      {chaves.map((key) => {
                        const value = parcela[key];
                        const height = Math.max((value / maxCompetencia) * 100, 5); // mínimo 5%

                        return (
                          <Tooltip
                            key={key}
                            label={`${labels[key]}: ${value} (${parcela.mes}/${parcela.ano})`}
                            hasArrow
                            placement="top"
                          >
                            <Box
                              w={{ base: "10px", md: "12px", lg: "16px" }}
                              h={`${height}%`}
                              bg={cores[key]}
                              borderRadius="4px 4px 0 0"
                              transition="all 0.3s ease"
                              _hover={{ opacity: 0.8 }}
                            />
                          </Tooltip>
                        );
                      })}
                    </Flex>

                    {/* mês da parcela */}
                    <Text fontSize="xs" mt={1}>
                      {parcela.mes}/{parcela.ano}
                    </Text>
                  </Flex>
                ))}
              </Flex>
            </Box>
          );
        })}
      </Flex>

      {/* LEGENDA */}
      <Flex my={6} pb={6} gap={6} wrap="wrap" justify="center">
        {chaves.map((key) => (
          <Flex key={key} align="center" gap={2}>
            <Box w="12px" h="12px" bg={cores[key]} borderRadius="2px" />
            <Text fontSize="sm">{labels[key]}</Text>
          </Flex>
        ))}
      </Flex>
    </Box>
  );
}